package io.horion.cv.api.datasource.payement

enum class PaymentMethod {
    OM,MOMO
}